import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    padding: '1rem',
    border: `1px solid ${Colors.gray}`,
    borderRadius: 3,
    margin: '1rem 0',
    width: '100%',
  },
  attachmentList: {
    listStyle: 'circle',
    paddingLeft: '1rem',

    '& > li': {
      padding: '0.2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },

    '& > li:hover': {
      backgroundColor: '#CECECE',
    },
  },

  listItem: {
    cursor: 'pointer',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingRight: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    '& a': {
      fontWeight: 600,
      color: Colors.primaryColor,
      textDecoration: 'none',
      '&:visited': {
        color: Colors.primaryColor,
      },
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
}))

export default styles
